export const API_URL = process.env.REACT_APP_API_URL || 'https://mechta-api.vova-prog-job.workers.dev';

export function imageUrl(path: string | null | undefined): string {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    return `${API_URL}${path.startsWith('/') ? '' : '/images/'}${path}`;
}
